<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        id="loadingDevTotal"
        class="text-center"
        :style="styleObject"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div id="idDevolucaoTotal">
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <canvas
              id="myChartValorDevolucaoTotal"
              class="chart-container"
            />
            <div
              v-if="enableValor"
              id="textoDevId"
              class="text-center"
            >
              DEVOLUÇÃO
            </div>
          </v-col>
        </v-row>
      </div>
      <v-row v-if="enableValor">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            id="valorDevolucao"
            class="text-center"
          >
            VALOR TOTAL <span :style="styleFaturamento">{{ valorDevolucao }}</span>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Comercial from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'

  export default {
    name: 'ShowMeta',
    emits: ['enableDevolucaoDetalhe'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleFaturamento: {
        color: '#C62828',
      },
      loading: false,
      error: null,
      dados: [],
      myChart: {},
      vendedores: [],
      selectMes: [],
      selectAno: [],
      valorDevolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      enableValor: false,
      labelsTotal: [],
      devolucao: [],
    }),

    created () {
      eventEmit.$on('update-dados-form', this.handleUpdateDados)

      eventEmit.$on('enable-dev-total', this.handleUpdateGrafico)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-form', this.handleUpdateDados)

      eventEmit.$off('enable-dev-total', this.handleUpdateGrafico)
    },

    methods: {
      handleUpdateDados (selectMes, selectAno, vendedores) {
        this.vendedores = vendedores
        this.selectMes = selectMes
        this.selectAno = selectAno

        this.valorDevolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.enableValor = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        this.showDevolucao()
      },

      handleUpdateGrafico (valorDetalheDevolucao, labelsDetalheTotal, quantidadeDetalheTotal) {
        this.valorDevolucao = valorDetalheDevolucao

        const ctx = document.getElementById('myChartValorDevolucaoTotal').getContext('2d')

        this.myChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labelsDetalheTotal,
            datasets: [
              {
                label: 'Devolução',
                data: quantidadeDetalheTotal,
                backgroundColor: '#4780b8',
                order: 1,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  gridLines: {
                    display: true,
                  },
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
              xAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  display: false,
                  barPercentage: 0.2,
                },
              ],
            },
            legend: {
              display: false,
              position: 'right',
              labels: {
                fontSize: 10,
                generateLabels: function (chart) {
                  return [
                    {
                      text: chart.data.datasets[0].data[0].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                      fillStyle: '#4780b8',
                    },
                  ]
                },
              },
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                },
                title: (tooltipItem) => {
                  return labelsDetalheTotal[tooltipItem[0].index]
                },
              },
            },
          },
        })
      },

      async showDevolucao () {
        this.loading = true
        this.error = false

        await Comercial.showTotalDevolucao(this.selectMes, this.selectAno, this.vendedores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.enableValor = true

            this.labelsTotal = resposta.data.labels
            this.devolucao = resposta.data.devolucao

            this.valorDevolucao = resposta.data.devolucao[0].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChartValorDevolucaoTotal').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Devolução',
                    data: resposta.data.devolucao,
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  yAxes: [
                    {
                      gridLines: {
                        display: true,
                      },
                      ticks: {
                        beginAtZero: true,
                      },
                    },
                  ],
                  xAxes: [
                    {
                      gridLines: {
                        display: false,
                      },
                      display: false,
                      barPercentage: 0.2,
                    },
                  ],
                },
                legend: {
                  display: false,
                  position: 'right',
                  labels: {
                    fontSize: 10,
                    generateLabels: function (chart) {
                      return [
                        {
                          text: chart.data.datasets[0].data[0].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                          fillStyle: '#4780b8',
                        },
                      ]
                    },
                  },
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há devoluções para os filtros selecionados') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)

            this.error1 = resposta.data.text
          } else if (resposta.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.error1 = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          eventEmit.$emit('enable-devolucao-detalhe', this.labelsTotal, this.devolucao, this.valorDevolucao)
        })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #idDevolucaoTotal {
      margin: 0 0 0 0;
    }

    #valorDevolucao {
      margin: -1rem 0 0 -5rem;
    }

    #myChartValorDevolucaoTotal {
      height: 248px !important;
      width: 321px !important;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width: 1380px)
  and (max-width: 1901px) {
    #myChartValorDevolucaoTotal {
      width: 262px !important;
      height: 303px !important;
      margin: 2rem 0 0 -2rem !important;
    }

    #valorDevolucao {
      margin: -0.2rem 0 0 -6rem;
      font-size: 14px;
    }

    #textoDevId {
      margin: 0 0 0 0 !important;
    }
  }

  @media screen
  and (min-width: 1902px) {
    #myChartValorDevolucaoTotal {
      width: 308px !important;
      height: 303px !important;
      margin: 2rem 0 0 -2rem;
    }
  }
</style>

<style lang="sass">
  #loadingDevTotal
    margin: 5rem 0 0 -5rem

  #idDevolucaoTotal
    margin: 0 0 0 -5rem

  #valorDevolucao
    margin: -0.2rem 0 0 -4rem
    font-size: 14px

  #myChartValorDevolucaoTotal
    width: 230px !important
    height: 220px !important

  #textoDevId
    margin: 0 0 0 5rem

</style>
